import React, { FC } from 'react'
import CheckboxListFacet from '../../components/CheckboxListFacet'
import { getSizeFacetOptions } from '../../helpers/facets'
import CustomSizeFields from './CustomSizeFields'
import {
  CustomHandleUpdateSelectedFacetParams,
  FacetServiceApi,
  UseReduxSearchProviderResponse,
  FacetOptionObject,
} from '../../types'
import useReduxSearchProvider from '../../hooks/useReduxSearchProvider'

type SizeFacetProps = {
  baseUrl: string
  nextAppRoute: string
  facetService: FacetServiceApi
  isCustomSizeEnabled?: boolean
  isPrintsFilter?: boolean
  facetName: string
  facetOptions: ReadonlyArray<FacetOptionObject>
  useReduxProviderHook?: () => UseReduxSearchProviderResponse
  customHandleUpdateSelectedFacet?: (params: CustomHandleUpdateSelectedFacetParams) => void
  customClickFacetOption?: (params: CustomHandleUpdateSelectedFacetParams) => void
}

const SizeFacet: FC<SizeFacetProps> = ({
  baseUrl,
  nextAppRoute,
  facetService,
  facetName,
  isCustomSizeEnabled,
  isPrintsFilter,
  facetOptions,
  useReduxProviderHook = useReduxSearchProvider,
  customHandleUpdateSelectedFacet,
  customClickFacetOption,
}) => {
  const {
    measurementUnit,
    selectedSize,
    sizeMinMax,
    selectedFacets,
    pathParams,
    sharedFacetNames,
    basicQueryParams,
  } = useReduxProviderHook()

  const sizeFacetOptions = getSizeFacetOptions({
    facetOptions,
    userSizePreference: measurementUnit,
    isPrintsFilter,
  })

  const additionalFacetsToChange = { width: [], height: [] }

  return (
    <CheckboxListFacet
      facetName={facetName}
      facetOptions={sizeFacetOptions}
      baseUrl={baseUrl}
      nextAppRoute={nextAppRoute}
      facetService={facetService}
      additionalFacetsToChange={additionalFacetsToChange}
      useReduxProviderHook={useReduxProviderHook}
      customHandleUpdateSelectedFacet={customHandleUpdateSelectedFacet}
      customClickFacetOption={customClickFacetOption}
    >
      {isCustomSizeEnabled && (
        <CustomSizeFields
          facetName={facetName}
          baseUrl={baseUrl}
          nextAppRoute={nextAppRoute}
          measurementUnit={measurementUnit}
          sizeMinMax={sizeMinMax}
          selectedSize={selectedSize}
          selectedFacets={selectedFacets}
          pathParams={pathParams}
          sharedFacetNames={sharedFacetNames}
          basicQueryParams={basicQueryParams}
          customHandleUpdateSelectedFacet={customHandleUpdateSelectedFacet}
          customClickFacetOption={customClickFacetOption}
        />
      )}
    </CheckboxListFacet>
  )
}

export default SizeFacet
